import { Grid, Typography } from '@mui/material';

export const ReservationCancelDenied = (props: any) => {
  const BackButton = () => {
    return (
      <button
        type="button"
        style={{ width: '100%', height: '48px', color: '#FFFFFF', textAlign: 'center', margin: 'auto' }}
        className="bg-primary flex relative rounded"
        onClick={() => {
          props.setActiveStep(0);
        }}
      >
        <div className="text-md m-auto">{'マイページに戻る'}</div>
      </button>
    );
  };

  return (
    <Grid container direction={'row'} justifyContent="center">
      <Grid item xs={1} md={3} sm={2} />
      <Grid item xs={10} md={6} sm={8}>
        <Typography className="font-bold" textAlign={'center'} marginTop={5}>
          {props.errorType}
        </Typography>
        <Typography textAlign={'center'} marginY={3}>
          {props.errorMessage}
        </Typography>
        <BackButton />
      </Grid>
      <Grid item xs={1} md={3} sm={2} />
    </Grid>
  );
};
